import { render, staticRenderFns } from "./staticTable.vue?vue&type=template&id=0d1f038b&scoped=true&"
import script from "./staticTable.vue?vue&type=script&lang=js&"
export * from "./staticTable.vue?vue&type=script&lang=js&"
import style0 from "./staticTable.vue?vue&type=style&index=0&id=0d1f038b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1f038b",
  null
  
)

export default component.exports